/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypeshorttext3Inputs */

const en_signuptypeshorttext3 = /** @type {(inputs: Signuptypeshorttext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short text`)
};

const de_signuptypeshorttext3 = /** @type {(inputs: Signuptypeshorttext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzer Text`)
};

/**
* | output |
* | --- |
* | "Short text" |
*
* @param {Signuptypeshorttext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypeshorttext3 = /** @type {((inputs?: Signuptypeshorttext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypeshorttext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypeshorttext3(inputs)
	return de_signuptypeshorttext3(inputs)
});
export { signuptypeshorttext3 as "signupTypeShortText" }